import script from "./ComputeSurfacePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeSurfacePage.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeSurfacePage.vue?vue&type=style&index=0&id=82f90b3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f90b3c"]])

export default __exports__